module.exports = __webpack_public_path__ + "img/skin_v5bo4q_c_scale,w_200-blur.54a2e09e.jpg";